export default __webpack_public_path__ + "static/media/arrowDown.6e74bf05.svg";